module.exports = __webpack_public_path__ + "static/media/apti_amc.9d5e6d7a.jpg";